import { render, staticRenderFns } from "./ContactCategoryForm.vue?vue&type=template&id=ebec7cfa&"
import script from "./ContactCategoryForm.vue?vue&type=script&lang=js&"
export * from "./ContactCategoryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports